export type AvailableWidgets = {
    employee: {
        overview: {
            onboardings: boolean;
            personal_data: boolean;
            note: boolean;
            skills: boolean;
            address: boolean;
            contact_persons: boolean;
            accesses: boolean;
            notifications: boolean;
            requests: boolean;
        };
        'positions-files': {
            position: boolean;
            structure: boolean;
        };
        'salaries-payrolls': {
            salary: boolean;
            bonus: boolean;
            real_wages: boolean;
        };
        documents: {
            payrolls: boolean;
            files: boolean;
        };
        properties: {
            properties: boolean;
            benefits: boolean;
        };
        evaluations: {
            kpi: boolean;
            reviews: boolean;
            growth: boolean;
        };
        analysis: {
            costs_chart: boolean;
            kpi_chart: boolean;
            kpi_evaluation: boolean;
            attendance_chart: boolean;
        };
        notes: {
            notes: boolean;
        };
        datetimes: {
            policy: boolean;
            chart: boolean;
            history: boolean;
            approvers: boolean;
        };
        setting: {
            salutation: boolean;
            integration_sso: boolean;
            role: boolean;
            kiosk_mode: boolean;
            branch: boolean;
            password_change: boolean;
            two_factor: boolean;
            language: boolean;
            help: boolean;
            signature: boolean;
            hidden_in_structure: boolean;
            contact_list: boolean;
        };
    };
    dashboard: {
        tabs: {
            note: boolean;
            todos: boolean;
        };
        employee_attendance_chart: {
            full_size: boolean;
            shortcut: boolean;
        };
        employee_shifts_chart: {
            full_chart_size: boolean;
        };
        widgets_config: WidgetConfigRow[]
    };
    employee_table: {
        columns: {
            contact: boolean;
            main_branch: boolean;
            teams: boolean;
            position_type: boolean;
            test_time_end: boolean;
            test_time_end_employee: boolean;
            position_from: boolean;
            position_to: boolean;
            in_company_from: boolean;
        };
        settings: {
            display_mode: string;
            show_only_primary_position: boolean;
        };
        custom_fields: {
            custom_field_definition_ID: number;
            enabled: boolean;
            label: string;
        }[];
    };
    employee_table_contractors: {
        columns: {
            contact: boolean;
            main_branch: boolean;
            teams: boolean;
            position_type: boolean;
            test_time_end: boolean;
            position_from: boolean;
            position_to: boolean;
            in_company_from: boolean;
        };
    };
    employee_table_archived: {
        columns: {
            contact: boolean;
            main_branch: boolean;
            teams: boolean;
            position_type: boolean;
            position_from: boolean;
            position_to: boolean;
        };
    };
    employee_contact_list: {
        columns: {
            contact: boolean;
            main_branch: boolean;
            teams: boolean;
        };
    };
    property_table: {
        settings: {
            is_compact: boolean;
        }
        columns: {
            category: boolean;
            image: boolean;
            state: boolean;
            code: boolean;
            serial_number: boolean;
            employee: boolean;
            date: boolean;
        }
        custom_fields: {
            custom_field_definition_ID: number;
            enabled: boolean;
            label: string;
        }[];
    };
    salary_table: {
        columns: {
            amount: boolean;
            frequency: boolean;
            from_to: boolean;
        }
        custom_fields: {
            custom_field_definition_ID: number;
            enabled: boolean;
            label: string;
        }[];
    };
    events_table: {
        settings: {
            show_only_own: boolean;
        }
    };
    employee_creation: {
        settings: {
            simple: boolean;
        }
    };
    attendance_stats: {
        placement: AttendanceStatsPlacement;
        employee_datetime_type_IDs: number[];
        show_weekly_stats: boolean;
        show_monthly_stats: boolean;
        show_days_in_company: boolean;
    };
};

export type AppearanceSettingCards = {
    dashboard?: boolean;
    employee?: boolean;
    employee_contact_list?: boolean;
    employee_creation?: boolean;
    employee_table?: boolean;
    employee_table_archived?: boolean;
    employee_table_contractors?: boolean;
    events_table?: boolean;
    property_table?: boolean;
    salary_table?: boolean;
    attendance_stats?: boolean;
    employee_table_display_mode?: boolean;
    events_table_display_mode?: boolean;
    questionnaire?: boolean;
    widget_default_template?: boolean;
    widget_templates?: boolean;
    custom_fields?: boolean;
    menu?: boolean;
    business_partner?: boolean;
};

export const hiddenEntities = ['attendance_stats'];

export const hiddenCategories = ['widgets_config'];

export const hiddenWidgets = ['display_mode'];

export const DASHBOARD_WIDGET_KEYS = [
    'absence_list',
    'alerts',
    'employee_attendance_chart',
    'employee_requests',
    'employee_shifts_chart',
    'employee_stats',
    'events',
    'internal_documents',
    'my_shifts',
    'pinned_post',
    'stats',
    'stopwatch',
    'tabs',
    'wall'
] as const;

export function isDashboardWidgetKey(key: string): key is DashboardWidgetKey {
    return (DASHBOARD_WIDGET_KEYS as readonly string[]).includes(key);
}

export type WidgetConfigRow = { name: DashboardWidgetKey, key: string, show: boolean, order: number, disabled: boolean, user_type: UserType };

export type DashboardWidgetKey = typeof DASHBOARD_WIDGET_KEYS[number];

export type UserType = 'employee' | 'user' | 'both';

export type AttendanceStatsPlacement = 'EMPLOYEE' | 'ATTENDANCE' | 'DASHBOARD';

